// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiResponse {
    static getAttributeTypeMap() {
        return PharmacyBiResponse.attributeTypeMap;
    }
}
PharmacyBiResponse.discriminator = undefined;
PharmacyBiResponse.additionalProperties = false;
PharmacyBiResponse.attributeTypeMap = [
    {
        "name": "plans",
        "baseName": "plans",
        "type": ""
    },
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "transactionDateTime",
        "baseName": "transactionDateTime",
        "type": "Date"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "transactionStatus",
        "baseName": "transactionStatus",
        "type": "boolean"
    },
    {
        "name": "customerId",
        "baseName": "customerId",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiResponse.js.map